import { Table as AntTable } from 'antd';
import styled from 'styled-components';

const Table = styled(AntTable)`
    ${(props) => props.onRow && 'cursor: pointer'}
`;
Table.defaultProps = {};

export default Table;
